import React from "react";
import Skeleton from "@mui/material/Skeleton";
import { Card } from "react-bootstrap";

const UserDetailsHeaderSkeleton = () => {
  return (
    <Card className="p-4 mb-0">
      <div className="d-flex justify-content-center flex-column gap-2 mb-4">
        <Skeleton className="m-0 p-0 " width={200} />
        <Skeleton className="m-0 p-0" width={300} />
      </div>

      <div className="row">
        <div className="col-md-3 col-sm-6 col-xs-12">
          <Skeleton className="fw-bold" />
          <Skeleton />
        </div>
        <div className="col-md-3 col-sm-6 col-xs-12">
          <Skeleton />
          <Skeleton />
        </div>
        <div className="col-md-3 col-sm-6 col-xs-12">
          <Skeleton />
          <Skeleton />
        </div>
        <div className="col-md-3 col-sm-6 col-xs-12">
          <Skeleton />
          <Skeleton />
        </div>
      </div>
    </Card>
  );
};

export default UserDetailsHeaderSkeleton;
